import React, { useCallback } from "react";
import { Field, Combobox, Option, SelectionEvents, OptionOnSelectData, Button } from "@fluentui/react-components";
import { ArrowSync16Regular } from "@fluentui/react-icons";
import { useRiskAnalysisStyles } from "@/pages/risk-analysis/styles";
import { useDocumentClassification } from "@/context/document-classification";

export const PromptConfigSection = () => {
  const styles = useRiskAnalysisStyles();
  const {
    errors,
    promptConfigs,
    selectedPromptConfig,
    fetchPromptConfigs,
    isFetchingPromptConfigs,
    setSelectedPromptConfig,
    currentClassification,
  } = useDocumentClassification();

  const handlePromptConfigChange = useCallback(
    (_event: SelectionEvents, data: OptionOnSelectData) => {
      const selected = promptConfigs.find((config) => config.id === data.optionValue);
      if (selected) setSelectedPromptConfig(selected);
    },
    [promptConfigs, setSelectedPromptConfig]
  );

  return (
    <div className={styles.configContainer}>
      <div className={styles.configInnerContainer}>
        <Field
          label="Prompt Configuration"
          validationState={errors.find((error) => error.field === "promptConfig") ? "error" : "none"}
          validationMessage={errors.find((error) => error.field === "promptConfig")?.message || ""}
          data-lpignore="true"
        >
          <div className={styles.configButtonContainer}>
            <Combobox
              data-lpignore="true"
              id="prompt-config-combobox"
              aria-labelledby="prompt-config-label"
              value={
                selectedPromptConfig
                  ? `${selectedPromptConfig?.promptName} ${selectedPromptConfig?.useAsDefault ? "(Default)" : ""}`
                  : ""
              }
              onOptionSelect={handlePromptConfigChange}
              placeholder="Select prompt configuration"
              disabled={isFetchingPromptConfigs || currentClassification?.rules.some((rule) => rule.isLoading)}
            >
              {promptConfigs.map((config) => (
                <Option
                  text={`${config.promptName} ${config.useAsDefault ? "(Default)" : ""}`}
                  key={config.id}
                  value={config.id}
                >
                  {config.promptName} {config.useAsDefault ? "(Default)" : ""}
                </Option>
              ))}
            </Combobox>
            <Button
              disabled={isFetchingPromptConfigs || currentClassification?.rules.some((rule) => rule.isLoading)}
              icon={<ArrowSync16Regular />}
              onClick={fetchPromptConfigs}
              aria-label="Refresh prompt configurations"
            />
          </div>
        </Field>
      </div>
    </div>
  );
};
